import { render, staticRenderFns } from "./FuhrparkView.vue?vue&type=template&id=35768b0f"
import script from "./FuhrparkView.vue?vue&type=script&lang=js"
export * from "./FuhrparkView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports